import { useQuery } from '@tanstack/react-query';
import { API } from '@/services/api.service';
import { QUERY_KEY } from '@/shared/constants';

/**
 * True when the career timeline request was rejected for the current role
 * (HTTP 403). Callers use this to hide the whole section instead of showing
 * a permission error to users who simply can't access the timeline.
 */
export const isCareerTimelineForbidden = (error) =>
  error?.response?.status === 403;

/**
 * Shared query for an employee's career timeline. React Query dedupes by key,
 * so a parent can call this to gate the section without triggering a second
 * request alongside the EmployeeCareerTimeline component itself.
 */
export function useEmployeeCareerTimeline(employeeId) {
  return useQuery({
    queryKey: [QUERY_KEY.employee, employeeId, 'careerTimeline'],
    queryFn: () => API.employees.getEmployeeCareerTimeline(employeeId),
    enabled: !!employeeId,
    retry: 1,
  });
}
